import React from 'react';
import { withCssSelector } from '../shared/withCssSelector';
import type { AIChatProps } from './types';
import { AIChatHeader } from './AIChatHeader';
import { AIChatMessageList } from './AIChatMessageList';
import { AIChatInput } from './AIChatInput';
import { AIChatRoot } from './AIChat.Styled';

export const AIChat = withCssSelector(
	React.forwardRef<HTMLDivElement, AIChatProps>(function AIChat(
		{
			title,
			messages,
			isLoading,
			isSending,
			inputValue,
			onInputChange,
			onSend,
			onClose,
			placeholder,
			modes,
			activeModeId,
			onModeChange,
			assistantAvatarSrc,
			assistantAvatarAlt,
			autoScroll = true,
			maxInputRows = 5,
			emptyState,
			height,
			maxWidth,
			...divProps
		},
		ref,
	) {
		return (
			<AIChatRoot
				ref={ref}
				role="region"
				aria-label={title}
				$height={height}
				$maxWidth={maxWidth}
				{...divProps}
			>
				<AIChatHeader
					title={title}
					onClose={onClose}
					modes={modes}
					activeModeId={activeModeId}
					onModeChange={onModeChange}
				/>
				<AIChatMessageList
					messages={messages}
					isLoading={isLoading}
					assistantAvatarSrc={assistantAvatarSrc}
					assistantAvatarAlt={assistantAvatarAlt}
					autoScroll={autoScroll}
					emptyState={emptyState}
				/>
				<AIChatInput
					value={inputValue}
					onChange={onInputChange}
					onSend={onSend}
					placeholder={placeholder}
					isSending={isSending}
					maxInputRows={maxInputRows}
				/>
			</AIChatRoot>
		);
	}),
	AIChatRoot.toString(),
);
